import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DatePicker, Form, Input, Select } from "antd";
import { Button, Col, Row } from "react-bootstrap";
import { createHoliday } from "store/loans";
import moment from "moment";

const CreateHolidays = () => {
  const [form] = Form.useForm();
  const [holidayDate, setHolidayDate] = useState(undefined);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const {
    users: { user },
  } = useSelector((state) => ({
    users: state.users,
  }));

  const handleFinish = (values) => {
    if (
      window.confirm(
        "Are you sure you want to create this new holiday, and move all payments forward?"
      )
    ) {
      setLoading(true)
      dispatch(
        createHoliday({
          ...values,
          state_id: user?.position === "SM" ? user?.state?.id : '',
          creator_id: user?.id,
          date: moment(values?.date).format("YYYY-MM-DD"),
        })
      ).then(() => setLoading(false));
    }
  };

  return (
    <div>
      <h3 className="page-title mb-4">Add Holiday</h3>

      <Form form={form} onFinish={handleFinish}>
        <Row>
          <Col>
            <Form.Item
              name="name"
              label="Type of Holiday"
              rules={[
                {
                  required: true,
                  message: "Please provide name",
                },
              ]}
            >
              <Input
                className="form-control"
                type="text"
                placeholder="Type of holiday"
              />
            </Form.Item>

            <Form.Item
              name="date"
              rules={[{ required: true, message: "Please provide date" }]}
              label="Date"
            >
              <DatePicker
                allowClear
                style={{ width: "100%" }}
                className="mb-3"
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          name="description"
          label="Additional detail (Optional)"
        >
          <Input
            className="form-control"
            type="text"
            placeholder="Description"
          />
        </Form.Item>

        <div>
          Note: All payments scheduled for an holiday date would be moved
          forward, and cannot be reversed by deleting the holiday.
        </div>

        <Row>
          <Col className="mt-3">
            <Button
              variant="primary"
              className="px-5"
              type="submit"
              disabled={loading}
            >
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export { CreateHolidays };
